<template>
  <g
    :class="{'gateway-wrapper': !isSelectedEvent(node.id)}"
    @dragover.prevent="eventDragoverHandler" @drop.prevent="eventDropHandler"
  >
    <!-- diamond shape for Exclusive Gateway -->
    <!-- class="shadow" -->
    <g
      :transform="`translate(${node.x}, ${node.y - 1.5})`"
    >
      <g :filter="isSelectedEvent(node.id) ? '' : 'url(#shadow-gateway)'" class="gateway-group">
        <g clip-path="url(#clip0_685_21724)">
          <polygon
            :id="'p-' + node.id"
            points="99.4802 39.9118, 99.6952 40.1446, 99.89 40.3921,100.064 40.653, 100.217 40.9259, 100.347 41.2094,100.455 41.5023, 100.541 41.8032, 100.602 42.1107,100.639 42.4235, 100.652 42.7402, 100.652 56.397,100.639 56.7137, 100.602 57.0265, 100.541 57.334,100.455 57.6349, 100.347 57.9278, 100.217 58.2113,100.064 58.4842, 99.89 58.7451, 99.6952 58.9926,99.4802 59.2255, 68.7609 89.9448, 67.4279 91.1761,66.0108 92.2914, 64.5173 93.2874, 62.9551 94.1609,61.3318 94.9088, 59.6551 95.5278, 57.9328 96.0148,56.1724 96.3666, 54.3818 96.5801, 52.5685 96.6519,50.7553 96.5801, 48.9646 96.3666, 47.2043 96.0148,45.4819 95.5278, 43.8053 94.9088, 42.182 94.1609,40.6197 93.2874, 39.1262 92.2914, 37.7091 91.1761,36.3762 89.9448, 5.65685 59.2255, 5.44176 58.9926,5.24695 58.7451, 5.07298 58.4842, 4.9204 58.2113,4.78976 57.9278, 4.68163 57.6349, 4.59656 57.334,4.53511 57.0265, 4.49783 56.7137, 4.48528 56.397,4.48528 42.7402, 4.49783 42.4235, 4.53511 42.1107,4.59656 41.8032, 4.68163 41.5023, 4.78976 41.2094,4.9204 40.9259, 5.07298 40.653, 5.24695 40.3921,5.44176 40.1446, 5.65685 39.9118, 36.3762 9.19245,37.7091 7.96109, 39.1262 6.84583, 40.6197 5.84984,42.182 4.97633, 43.8053 4.22846, 45.4819 3.60943,47.2043 3.12242, 48.9646 2.77061, 50.7553 2.55719,52.5685 2.48534, 54.3818 2.55719, 56.1724 2.77061,57.9328 3.12242, 59.6551 3.60943, 61.3318 4.22846,62.9551 4.97633, 64.5173 5.84984, 66.0108 6.84583,67.4279 7.96109, 68.7609 9.19245"
            :data-test="svgGraphData?.[node.id]?.name"
            :data-test-version="svgGraphData?.[node.id]?.version"
            :class="[{ draggable: true, 'connection-target': connectionTarget }, colorName ? `theme-fill-${colorName}` : '']"
            @click="onGatewayClick($event)"
            :style="{
              fill: isSelectedEvent(node.id) ? lightenColor(color) : (!colorName ? color : undefined),
              stroke: isSelectedEvent(node.id) ? darkenColor(color) : (!colorName ? color : undefined),
              strokeWidth: ((isSelectedEvent(node.id) || node.outlined) ? 2 : 0) + 'px',
              'fill-opacity': (!isSelectedEvent(node.id) && node.outlined) ? '0' : undefined
            }"
          />
        </g>
        <mask id="mask0_685_21724" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="10" y="8" width="21"
              height="21">
          <rect x="10.1127" y="8.14215" width="20" height="20" fill="black"/>
        </mask>
      </g>

      <defs>
        <filter
          id="shadow-gateway"
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="8"/>
          <feGaussianBlur stdDeviation="5.5"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_631_3776"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_631_3776" result="effect2_dropShadow_631_3776"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_631_3776" result="shape"/>
        </filter>
        <filter id="shadow-event-hover" x="-50%" y="-50%" width="200%" height="200%">
          <!-- First shadow (0px 3px 6px rgba(0, 0, 0, 0.20)) -->
          <feOffset dx="0" dy="3" result="offset1" />
          <feGaussianBlur stdDeviation="3" result="blur1" />
          <feFlood flood-color="rgba(0, 0, 0, 0.20)" />
          <feComposite in2="blur1" operator="in" result="shadow1" />

          <!-- Second shadow (0px 6px 16px rgba(0, 0, 0, 0.12)) -->
          <feOffset dx="0" dy="6" result="offset2" />
          <feGaussianBlur stdDeviation="8" result="blur2" />
          <feFlood flood-color="rgba(0, 0, 0, 0.12)" />
          <feComposite in2="blur2" operator="in" result="shadow2" />

          <!-- Combine shadows -->
          <feMerge>
            <feMergeNode in="shadow1" />
            <feMergeNode in="shadow2" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <clipPath id="clip0_685_21724">
          <polygon
            points="99.4802 39.9118, 99.6952 40.1446, 99.89 40.3921,100.064 40.653, 100.217 40.9259, 100.347 41.2094,100.455 41.5023, 100.541 41.8032, 100.602 42.1107,100.639 42.4235, 100.652 42.7402, 100.652 56.397,100.639 56.7137, 100.602 57.0265, 100.541 57.334,100.455 57.6349, 100.347 57.9278, 100.217 58.2113,100.064 58.4842, 99.89 58.7451, 99.6952 58.9926,99.4802 59.2255, 68.7609 89.9448, 67.4279 91.1761,66.0108 92.2914, 64.5173 93.2874, 62.9551 94.1609,61.3318 94.9088, 59.6551 95.5278, 57.9328 96.0148,56.1724 96.3666, 54.3818 96.5801, 52.5685 96.6519,50.7553 96.5801, 48.9646 96.3666, 47.2043 96.0148,45.4819 95.5278, 43.8053 94.9088, 42.182 94.1609,40.6197 93.2874, 39.1262 92.2914, 37.7091 91.1761,36.3762 89.9448, 5.65685 59.2255, 5.44176 58.9926,5.24695 58.7451, 5.07298 58.4842, 4.9204 58.2113,4.78976 57.9278, 4.68163 57.6349, 4.59656 57.334,4.53511 57.0265, 4.49783 56.7137, 4.48528 56.397,4.48528 42.7402, 4.49783 42.4235, 4.53511 42.1107,4.59656 41.8032, 4.68163 41.5023, 4.78976 41.2094,4.9204 40.9259, 5.07298 40.653, 5.24695 40.3921,5.44176 40.1446, 5.65685 39.9118, 36.3762 9.19245,37.7091 7.96109, 39.1262 6.84583, 40.6197 5.84984,42.182 4.97633, 43.8053 4.22846, 45.4819 3.60943,47.2043 3.12242, 48.9646 2.77061, 50.7553 2.55719,52.5685 2.48534, 54.3818 2.55719, 56.1724 2.77061,57.9328 3.12242, 59.6551 3.60943, 61.3318 4.22846,62.9551 4.97633, 64.5173 5.84984, 66.0108 6.84583,67.4279 7.96109, 68.7609 9.19245" />
        </clipPath>
      </defs>
    </g>

    <!-- editable Event Label -->
    <foreignObject
      v-if="node.showConditionLabelOnEvent"
      :x="node.x - 20"
      :y="node.y - 28"
      width="120"
      height="32"
    >
      <bpmn-event-label
        :node="node"
        :condition-label="getConnectionLabel(node, node.parents[0])"
        :characterLimit="30"
        @change-event="$emit('change-event', $event)"
        @label-blur="blurOnConditionLabels($event, node, node.parents[0])"
        @label-focus="focusOnConditionLabel"
      ></bpmn-event-label>
    </foreignObject>

    <!-- editable Exclusive Gateway Name -->
    <foreignObject
      :x="node.x + 15.5"
      :y="node.y + 23.085"
      width="73"
      height="48"
    >
      <div class="d-flex align-center justify-center h-100">
        <div @mousedown="onGatewayClick($event)" class="d-flex justify-center h-100" style="max-height: 48px;">
          <div
            ref="gatewayName"
            :id="node.id"
            class="gateway-name draggable h-100"
            :data-test-decision-name="svgGraphData[node.id]?.name"
            :data-test-version="svgGraphData[node.id]?.version"
            :contenteditable="!$store.state.isWorkflowDisabled && node.id == $route.params.eventId && selectedEventIds.length <= 1"
            @keydown.stop.exact="checkCharacterLimit($event, 40)"
            @keydown.shift.exact="checkCharacterLimit($event, 40)"
            @keydown.stop.prevent.enter="toggleFocus"
            @keydown.stop.esc="restoreValue($event, node.name)"
            @blur.stop="blurOnDescription($event, node)"
            @keydown.stop.tab.exact="moveRight($event)"
            @keydown.stop.tab.shift.exact="moveLeft($event)"
            @paste="onPaste($event, $refs.gatewayName, 40)"
            v-text="node.name"
            style="vertical-align: top; overflow-wrap: anywhere"
            @input="() =>updateFontSizeDynamically($refs.gatewayName, false)"
          ></div>
        </div>
      </div>
    </foreignObject>
  </g>
</template>

<script>
import BpmnEventLabel from '@/components/BpmnEventLabel'
import { diagramHelpers } from '@/mixins/diagramHelpers.js'
import { updateFontSizeDynamically } from '@/utils/update-font.js'
import { darkenColor, lightenColor, getDarkThemeColor, getColorName } from '@/utils/color'
import { isDarkTheme } from '@/composables/useAppTheme'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    BpmnEventLabel
  },

  mixins: [diagramHelpers],

  props: {
    node: Object,
    connectionTarget: Boolean,
    svgGraph: Object,
    svgGroups: Object,
    svgLanes: Object,
    workflow: Object,
    eventDefinition: Object,
    selectedEventIds: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    updateFontSizeDynamically,
    darkenColor,
    lightenColor,
    moveRight (event) {
      this.$emit('move-right')
      event.target.blur()
      event.preventDefault()
    },
    moveLeft (event) {
      this.$emit('move-left')
      event.target.blur()
      event.preventDefault()
    },
    onGatewayClick (event) {
      if (this.connectionTarget) {
        this.addConnection(this.node.id)
      } else {
        // Check if shift key is pressed for multi-selection
        if (event && event.shiftKey) {
          event.preventDefault()
          // Prevent mousedown propagation to avoid triggering box selection
          event.stopPropagation()
          // Call parent's shift-click handler
          this.$parent.handleShiftClickSelection(this.node.id)
        } else {
          // Don't clear selection if we just finished dragging
          if (this.$parent?.justFinishedDragging) return

          // Clear any multi-selection and select only this gateway
          this.$parent?.clearMultiSelection?.()
          this.changeSelectedEvent(this.node.id)
        }
      }
    },

    eventDragoverHandler (ev) {
      ev.dataTransfer.dropEffect = 'move'
    },

    eventDropHandler (ev) {
      const cardTypeId = ev.dataTransfer.getData('text/plain')
      this.addCardToEvent(this.node.id, cardTypeId, '<p>New card</p>')
    }
  },

  computed: {
    ...mapGetters({
      svgGraphData: 'svgGraphData/svgGraphData',
      baseData: 'svgGraphData/baseData'
    }),
    ...mapState({
      cardTypes: state => state.cardTypes.cardTypes
    }),
    color () {
      const rgb = this.node.color ? this.node.color.rgb : this.eventDefinition.color.rgb
      return isDarkTheme() ? getDarkThemeColor(rgb) : rgb
    },
    colorName () {
      const rgb = this.node.color ? this.node.color.rgb : this.eventDefinition.color.rgb
      return getColorName(rgb)
    }
  },

  mounted () {
    if (this.$refs.gatewayName) {
      updateFontSizeDynamically(this.$refs.gatewayName, false, 12)
    }
    if (this.node.selectEventText) {
      // yuriy:
      // for some reason `this.$nextTick` doesn't fix the problem
      // with async state change of the component
      // `setTimeout` does a trick and allows to select the text
      // when element becomes selected
      //
      // staffan:
      // diabled because of cypress tests
      // window.setTimeout(() => {
      //   const node = this.$el.querySelector('.gateway-name')
      //   if (node) {
      //     const selection = window.getSelection()
      //     const range = document.createRange()
      //     range.selectNodeContents(node)
      //     selection.removeAllRanges()
      //     selection.addRange(range)
      //   }
      // }, 1000)
    }
  }
}
</script>

<style scoped>
.gateway-wrapper:hover .gateway-group {
  filter: url(#shadow-event-hover);
}

.connection-target {
  animation: target 0.8s ease-in-out both infinite;
}

.text-centered {
  justify-content: center;
  line-height: 1.2
}

.gateway-name {
  padding: 4px;
  text-align: center;
  border-radius: 4px;
  word-break: break-word;
  color: var(--text-dark);
  font-weight: 500;
  line-height: 12px;
  display: inline-flex;
  align-items: center;
}

.gateway-name:focus-visible {
  outline: none;
}

@keyframes target {
  0% {
    stroke-width: 2px;
    stroke: black;
  }

  50% {
    stroke-width: 5px;
    stroke: black;
  }

  100% {
    stroke-width: 2px;
    stroke: black;
  }
}

/* .shadow {
  -webkit-filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
  filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.7));
} */
</style>
